export default "__VITE_ASSET__e327ef9a__"